import React from "react";
import { Provider } from "react-redux";
import reducer from "./redux/organizationsReducer";
import rootSaga from "./redux/organizationsSagas";
import ErrorBoundary from "../../../components/errorBoundary/errorBoundary";
import { createReduxStore } from "../../../utils/createReduxStore";
import { OrganizationsModule } from "./OrganizationsModule";

const Organizations = (props) => {
  const { notifications } = props;

  return (
    <Provider store={createReduxStore(reducer, "organizations", rootSaga)}>
      <ErrorBoundary moduleName="organizations" {...notifications}>
        <OrganizationsModule params={{ environment: notifications.env }} />
      </ErrorBoundary>
    </Provider>
  );
};

export default Organizations;
